import React from 'react'
import Label from 'components/general/Label';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';

export default function BioAnchors({ data }) {
  const { mirs_code } = useUrlFriendlyToParameters()
  const bioData = data?.team ? data?.team : data?.horse ? data?.horse : data?.person;

  let disciplines = '';
  if (data?.horse) {
    disciplines = bioData?.discipline?.code;
  } else {
    bioData?.disciplines?.forEach((d, index) => {
      disciplines = index === 0 ? d?.code : `${d?.code}_${disciplines}`
    });
  };

  const data_id = `${mirs_code}_${disciplines}`

  return (
    <ul id="navigator" className="list-inline text-center p-1 bio-navigator">
      {bioData?.registeredEvents &&
        <li id="events_navigator" className="list-inline-item">
          <a href="#events"><Label data="LabelEventsMedals" ocsLabel={true}/></a>
        </li>
      }
      {bioData?.athletes &&
        <li id="records_navigator" className="list-inline-item">
          <a href="#members"><Label data="LabelTeamMembers" ocsLabel={true}/></a>
        </li>
      }
      {bioData?.teamCoaches &&
        <li id="records_navigator" className="list-inline-item">
          <a href="#officials"><Label data="LabelTeamOfficials" ocsLabel={true}/></a>
        </li>
      }
      {bioData?.records &&
        <li id="records_navigator" className="list-inline-item">
          <a href="#records"><Label data="LabelRecords" ocsLabel={true}/></a>
        </li>
      }
      {(bioData?.schedules && bioData?.mainFunction?.category !== 'J') &&
        <li id="schedule_navigator" className="list-inline-item">
          <a href="#schedule" title={<Label data="LabelSchedule" />}><Label data="LabelSchedule" ocsLabel={true}/></a>
        </li>
      }
      {(bioData?.participantBio || bioData?.teamBio) &&
        <li id="bio_navigator" className="list-inline-item">
          <a href="#bio"><Label data="HeaderBio" ocsLabel={true}/></a>
        </li>
      }
      {(bioData?.participantBio?.interest?.addInformation || bioData?.teamBio?.interest?.addInformation) &&
        <li id="additionalInformation_navigator" className="list-inline-item">
          <a href="#addInformation"><Label data="HeaderGeneralInterest"  ocsLabel={true}/></a>
        </li>
      }
      {(bioData?.participantBio?.interest?.milestones || bioData?.teamBio?.interest?.milestones) &&
        <li id="milestones_navigator" className="list-inline-item">
          <a href="#milestones"><Label data="HeaderMilestones" ocsLabel={true}/></a>
        </li>
      }
      {data?.horse?.horseBio && <>
        <li id="bio_navigator" className="list-inline-item">
          <a href="#bio"><Label data="HeaderBio" ocsLabel={true}/></a>
        </li>
        <li id="bio_navigator" className="list-inline-item">
          <a href="#generalInfo"><Label data="HeaderGeneralInformation" ocsLabel={true}/></a>
        </li>
      </>}
      <li id="relatedNews" className="d-none relatedNews list-inline-item" data-id={data_id} data-discipline={disciplines}>
        <a href="#"><Label data="HeaderRelatedNews" ocsLabel={true}/></a>
      </li>
    </ul>
  )
}